import React from "react";
import Banner from "./Banner";

const ServiceAgreement = () => {
  return (
    <div className="w-full min-h-screen py-10">
      <div className="p-4 md:p-8 lg:p-10 max-w-7xl mx-auto w-full grid place-content-center text-left">
        <h1 className="text-3xl md:text-4xl font-bold text-[#0F172A] text-center mb-8">
          SERVICE AGREEMENT
        </h1>

        <p className="text-[#1F2937] mb-6">
          This Service Agreement ("Agreement") is made on [Date] by and between:
        </p>

        <div className="mb-6">
          <strong className="text-[#0F172A]">1. [Client's Name]</strong>
          <p className="text-[#1F2937]">Address: [Client's Address]</p>
          <p className="text-[#1F2937]">
            (hereinafter referred to as "Client")
          </p>
        </div>

        <div className="mb-6">
          <strong className="text-[#0F172A]">
            2. [Research Analyst's Name]
          </strong>
          <p className="text-[#1F2937]">
            Address: [Research Analyst's Address]
          </p>
          <p className="text-[#1F2937]">
            Registration No.: [SEBI Registration No.]
          </p>
          <p className="text-[#1F2937]">
            (hereinafter referred to as "Research Analyst")
          </p>
        </div>

        <p className="text-[#1F2937] mb-6">
          WHEREAS, the Research Analyst is registered with the Securities and
          Exchange Board of India Registration No. INH000020280 (SEBI) under the
          Research Analyst Regulations and is engaged in providing research and
          analysis services pertaining to the share and commodity markets.
        </p>

        <h2 className="text-2xl font-semibold text-[#0F172A] text-center mt-8 mb-6">
          NOW, THEREFORE
        </h2>

        <p className="text-lg font-semibold text-[#1F2937] mb-6">
          In consideration of the mutual covenants contained herein, the parties
          agree as follows:
        </p>

        {/** Section Template */}
        {[
          {
            title: "1. Scope of Services",
            content: [
              "Research reports on shares and commodities.",
              "Research recommendations / Calls / Tips will be based on thorough analysis.",
              "Market updates and forecasts.",
              "Customized Research services as per Client's requirements.",
              "Mode of Services will be SMS.",
            ],
          },
          {
            title: "2. Fees and Payment Terms",
            content: [
              "The Client agrees to pay the Research Analyst a fee/Service Charge for the services rendered purely and exclusively for research services.",
              "All the service provided by the research analyst described in Annexure A-1 is understood and agreed to avail the services.",
              "All the consideration paid to the NextEra Research  by the client is for the purely and exclusively for the Research services only.",
              "NextEra Research  does not offer any other financial services such as Portfolio Management or Mutual Funds.",
              "No cancellation, holding, or refund policy applies once the client subscribes to the research services.",
            ],
          },
          {
            title: "3. Other Terms and Conditions",
            content: [
              "NextEra Research  does not provide any profit warranty or guarantee.",
              "Official communication will only be sent via www.nexteraresearch.in domain.",
              "Investment in the market is subject to risks borne solely by the client.",
              "Past performance is not indicative of future returns.",
              "Research services will be delivered via SMS, and any changes will be communicated by email.",
            ],
          },
          {
            title: "4. Limitation of Liability",
            content: [
              "The Research Analyst is not liable for any damages arising from the Client’s use of the research and recommendations.",
            ],
          },
          {
            title: "5. Governing Law",
            content: [
              "This Agreement shall be governed by and construed in accordance with the laws of India.",
            ],
          },
          {
            title: "6. Dispute Resolution",
            content: [
              "Any disputes arising from this Agreement shall be resolved through arbitration under the Arbitration and Conciliation Act.",
            ],
          },
          {
            title: "7. Entire Agreement",
            content: [
              "This Agreement constitutes the entire understanding between the parties and supersedes prior agreements.",
              "The parties have executed this Service Agreement as of the date above.",
            ],
          },
        ].map((section, index) => (
          <div key={index} className="mb-8">
            <h3 className="text-xl font-semibold text-[#0F172A] mb-4">
              {section.title}
            </h3>
            <ul className="list-disc ml-6 space-y-2">
              {section.content.map((item, i) => (
                <li key={i} className="text-[#1F2937]">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}

        {/** Signatures */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-10">
          <div>
            <strong className="text-[#0F172A]">Client:</strong>
            <p className="text-[#1F2937] my-1">[Client's Name]</p>
            <p className="text-[#1F2937]">Date: ________________</p>
          </div>
          <div>
            <strong className="text-[#0F172A]">Research Analyst:</strong>
            <p className="text-[#1F2937] my-1">[Research Analyst's Name]</p>
            <p className="text-[#1F2937]">Date: ________________</p>
          </div>
        </div>
      </div>
      <Banner />
    </div>
  );
};

export default ServiceAgreement;
